import { Square, Box, Link } from "react-feather";
import { ListBox, ListBoxItem } from "react-aria-components";

import styles from "./boxy-list.module.css";

export function BoxyList({
  label,
  children,
}: {
  children: React.ReactNode;
  label: string;
}) {
  return (
    <ListBox
      className={styles.boxyList}
      aria-label={label}
      selectionMode="single"
    >
      {children}
    </ListBox>
  );
}

export type SupportedIcon = "square" | "box" | "link";

function itemIcon(icon?: SupportedIcon) {
  if (typeof icon !== "string") {
    return <></>;
  }

  switch (icon) {
    case "box":
      return <Box />;
    case "square":
      return <Square />;
    case "link":
      return <Link />;
  }
}

export function BoxyListItem({
  children,
  textValue,
  active,
  icon,
  disabled,
  onClick,
}: {
  onClick?: () => void;
  icon?: SupportedIcon;
  disabled?: boolean;
  active?: boolean;
  children: React.ReactNode;
  textValue: string;
}) {
  return (
    <ListBoxItem
      isDisabled={disabled === true}
      onClick={onClick}
      className={styles.boxyListItem}
      textValue={textValue}
      aria-label={textValue}
      data-active={active}
    >
      {itemIcon(icon)}
      <div className={styles.listItemContent}>{children}</div>
    </ListBoxItem>
  );
}
